<template>
  <section class="section">
    <div class="section__container carouselV1">
      <!-- <ul class="categories-navigation">-->
      <hooper :settings="hooperSettings" :ref="`carousel`" :class="hooperClasses" >
        <!--  <li v-for="category in categoryList" :key="category.item.uuid">-->
        <hooper-slide v-for="(category, index) in categoryList" :key="category.item.uuid" :index="index">
          <pg-button
              v-bind:key="category.item.uuid"
              :href="category.link | mgnlLink('url')"
              :styleType="'text'"
              :size="'medium'"
          >
            <icon-text :iconName="category.item.icon" :title="category.item.title"/>
          </pg-button>
        </hooper-slide>
        <!--  </li>-->
        <!--</ul>-->
      </hooper>
    </div>
  </section>
</template>
<script>
  import IconText from "../IconText/IconText.vue";
  import PgButton from "../Button/Button.vue";
  import {Hooper, Slide as HooperSlide} from "hooper";

  export default {

    name: "MenuIconText",
    components: {
      Hooper,
      HooperSlide,
      PgButton,
      IconText
    },
    data() {
      return {
        slidenum: 0,
        index: 0,
        currentTab: 0,
        hooperSettings: {
          initialSlide: 0,
          itemsToShow: 2.5,
          itemsToSlide: 1,
          centerMode: false,
          wheelControl: false,
          infiniteScroll: false,
          touchDrag: true,
          mouseDrag: true,
          trimWhiteSpace: true,
          breakpoints: {
            640: {
              initialSlide: 0,
              itemsToShow: 4.5,
              itemsToSlide: 1,
              centerMode: false,
              touchDrag: true,
              mouseDrag: true,
              infiniteScroll: false
            },
            1024: {
              initialSlide: 0,
              itemsToShow: 7.5,
              itemsToSlide: 1,
              centerMode: false,
              touchDrag: true,
              mouseDrag: true,
              infiniteScroll: false
            }
          }
        },
        isPrevDisabled: false,
        isNextDisabled: false,
        itemsLessThanItemsToShow: {
          small: 2.5,
          medium: 4.5,
          large: 7.5
        }
      }
    },
    props: {
      categoryList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      hooperClasses() {
        return [
          "categories-navigation hooper--partial-slide ",
          this.categoryList.length <= this.itemsLessThanItemsToShow[this.$mq] ? "centered" : ""
        ]
      },
    }
  };
</script>